import { useMemo } from "react";
import { useTranslations } from "use-intl";

import type { FindHotelsOutputData } from "@/app/lib/types/codegen";
import { Image } from "../Image";

interface HotelOverviewProps {
  hotel: FindHotelsOutputData;
  onImageClick?: () => void;
}

export const HotelImages = ({ hotel, onImageClick }: HotelOverviewProps) => {
  const t = useTranslations();

  // Get first 4 images that are different from mainImage
  const additionalImages = useMemo(() => {
    const images: string[] = [];
    for (const url of hotel.imagesUrls) {
      if (images.length >= 4) break;
      if (url !== hotel.mainImageUrl) {
        images.push(url);
      }
    }
    return images;
  }, [hotel.imagesUrls, hotel.mainImageUrl]);

  return (
    <>
      <div className="mb-2 flex aspect-[326/180] w-full items-center justify-center overflow-hidden rounded-lg bg-gray-100 text-center text-xs text-text-tertiary">
        {hotel.mainImageUrl ? (
          <button
            type="button"
            className="h-full w-full"
            onClick={onImageClick}
          >
            <Image
              className="h-full w-full object-cover"
              src={hotel.mainImageUrl}
              alt={hotel.name}
            />
          </button>
        ) : (
          <span>{t("noImage")}</span>
        )}
      </div>
      {additionalImages.length > 0 ? (
        <div className="mb-4 grid grid-cols-4 gap-2">
          {additionalImages.map((url, index) => {
            return (
              <button
                key={url}
                type="button"
                onClick={onImageClick}
                className="aspect-square overflow-hidden rounded-sm bg-gray-100"
              >
                <Image
                  className="h-full w-full object-cover"
                  src={url}
                  alt={`hotel${index}`}
                />
              </button>
            );
          })}
        </div>
      ) : null}
    </>
  );
};
